// Google Analytics 4 and Google Ads via gtag.js, which the layouts load from Google

import {CAMPAIGN_PARAM_KEY, getParameter, MEDIUM_PARAM_KEY, SOURCE_PARAM_KEY} from '../lib/params.ts'
import {cookiesAccepted} from './consent.ts'

const GA4_MEASUREMENT_ID = 'G-QFVQHKQGTX'
const GOOGLE_ADS_ID = 'AW-481483117'

/**
 * localhost, LAN IPs and *.local (e.g. the LAN IP set by `dev-build-util.js`). Matching private hosts instead of "not production" ensures
 * production pages served through proxies (e.g. Google Translate's *.translate.goog) are still tracked.
 */
const IS_LOCAL_DEV = /^(localhost|127\.|10\.|192\.168\.|172\.(1[6-9]|2\d|3[01])\.)|\.local$/.test(location.hostname)

/** Defines the global `gtag()` and configures GA4 and Google Ads, with GDPR-compliant consent mode based on the cookie banner (see consent.ts) */
export function initAnalytics() {
    window.dataLayer = window.dataLayer || []
    window.gtag = function () {
        // biome-ignore lint/complexity/noArguments: gtag.js only processes `arguments` objects, not arrays
        window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())

    const trackingRule = cookiesAccepted() ? 'granted' : 'denied'
    window.gtag('consent', 'default', {
        analytics_storage: trackingRule,
        ad_storage: trackingRule,
        ad_user_data: trackingRule,
        ad_personalization: trackingRule
    })

    // Transmit UTM params to GA4 (required as params.ts strips them from the URL). Only set if given to keep the default attribution.
    const campaign: Record<string, string> = {}
    const utmMedium = getParameter(MEDIUM_PARAM_KEY)
    const utmSource = getParameter(SOURCE_PARAM_KEY)
    const utmCampaign = getParameter(CAMPAIGN_PARAM_KEY)
    if (utmMedium) campaign.medium = utmMedium
    if (utmSource) campaign.source = utmSource
    if (utmCampaign) campaign.name = utmCampaign

    // Local dev runs GA4 in debug mode: its events show up in GA4's DebugView, but are excluded from reports by the "Developer traffic" data filter.
    // Only set if true: GA4 enables debug mode for any value, even false. Google Ads has no such filter, so it stays off on local dev.
    window.gtag('config', GA4_MEASUREMENT_ID, IS_LOCAL_DEV ? {campaign, debug_mode: true} : {campaign})
    if (!IS_LOCAL_DEV) window.gtag('config', GOOGLE_ADS_ID)
}

